module.exports = __webpack_public_path__ + "static/media/GF.e7f7297e.svg";